import { z } from 'zod'

export const trainerInvoicePublicShareExceptionResponseSchema = z.record(z.unknown())
export type TrainerInvoicePublicShareExceptionResponse = z.infer<typeof trainerInvoicePublicShareExceptionResponseSchema>
